import styled from 'styled-components';

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WbFallback = () => {
  return (
    <Container>
      <img src="https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/images/xiqSpinner.gif" />
    </Container>
  );
};
